import API from 'services/api';

import { IICal } from '../models';

export const getICalUnitLite = ({ unitId }: { unitId: string }): Promise<IICal> =>
  API.get(`/api/renter/accommodation/properties/iCal/units/${unitId}`)?.then(
    response => response?.data,
  );
